export default __webpack_public_path__ + "static/media/480_dummy2016-restaurant04-mobile-de.94239470.png";